<template>
  <div class="wrapper">
    <div class="head">
      <h4>加入知春</h4>
    </div>

    <div class="content">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="showModal(item)"
      >
        <h4>{{ item.title }}</h4>
        <p>{{ item.tip }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Model from "./model";
import { information } from "@/util/recruit";
export default {
  data() {
    return {
      list: information,
    };
  },
  computed: {
    ...mapGetters({
      language: "getType",
    }),
  },

  methods: {
    ...mapMutations(["changeRModel", "setInfo"]),
    showModal(item) {
      this.changeRModel(true);
      this.setInfo(item);
    },
  },
  components: {
    Model,
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  padding-bottom: 1rem;
  .head {
    width: 3.24rem;
    border-bottom: 0.01rem solid rgba(51, 51, 51, 0.25);
    padding-bottom: 0.13rem;
    margin: 0.4rem auto 0;
    h4 {
      font-size: 0.36rem;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      opacity: 0.9;
      text-align: center;
    }
  }
  .content {
    width: 100%;
    margin: 0.16rem auto 0 !important;
    justify-content: space-around;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 2.4rem;
      height: 1.6rem;
      margin-top: 0.2rem;
      text-align: center;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0.03rem 0.04rem 0.21rem 0 rgba(70, 214, 177, 0.24);
      border-radius: 0.15rem;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/recruit.vue